import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import PhoneIcon from '@mui/icons-material/Phone';
import Box from '@mui/material/Box';
import Container from '@mui/material/Container';
import Divider from '@mui/material/Divider';
import Grid from '@mui/material/Grid';
import Link from '@mui/material/Link';
import Typography from '@mui/material/Typography';
import type { FC } from 'react';

import MetaBusinessIcon from '../../../assets/images/logos/MetaBusinessPartnerBadge.png';
import RelifIcon from '../../../assets/images/logos/RelifLogoBlanco.png';

const Footer: FC = () => {
  const currentYear = new Date().getFullYear();

  const quickLinks = [
    { name: 'Inicio', href: '/welcome' },
    { name: 'Quiénes Somos', href: '/quienes-somos' },
    { name: 'Contáctanos', href: '/contactanos' },
  ];

  return (
    <Box component="footer" sx={{ backgroundColor: '#15183A', color: 'white' }}>
      <Container maxWidth="lg" sx={{ px: { xs: 2, sm: 3, lg: 4 } }}>
        <Grid container spacing={4} sx={{ py: 6 }}>
          {/* Company Info */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Link href="https://www.relif.cl/">
              <Box
                component="img"
                src={RelifIcon}
                alt="Relif"
                sx={{ height: '4.5em', width: 'auto', alignSelf: 'flex-start', mb: 2 }}
              />
            </Link>
            <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 3, lineHeight: 1.6 }}>
              Inteligencia Artificial para el rubro automotriz, seguros y bancario.
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid size={{ xs: 12, sm: 6, md: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'semibold', mb: 2 }}>
              Enlaces Rápidos
            </Typography>
            <Box component="ul" sx={{ listStyle: 'none', p: 0, m: 0 }}>
              {quickLinks.map((link) => (
                <Box component="li" key={link.name} sx={{ mb: 1 }}>
                  <Link
                    href={link.href}
                    sx={{
                      color: 'rgba(255, 255, 255, 0.7)',
                      textDecoration: 'none',
                      fontSize: '0.875rem',
                      '&:hover': {
                        color: 'white',
                        transition: 'color 0.3s ease',
                      },
                    }}
                  >
                    {link.name}
                  </Link>
                </Box>
              ))}
            </Box>
          </Grid>

          {/* Contact Info */}
          <Grid size={{ xs: 12, md: 3 }}>
            <Typography variant="h6" sx={{ fontWeight: 'semibold', mb: 2 }}>
              Información de Contacto
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <PhoneIcon sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '1.25rem' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  +56 9 92268245
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <EmailIcon sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '1.25rem' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  contacto@relif.cl
                </Typography>
              </Box>
              <Box sx={{ display: 'flex', alignItems: 'center', gap: 1.5 }}>
                <LocationOnIcon sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '1.25rem' }} />
                <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
                  San Patricio 4266, Vitacura, Chile
                </Typography>
              </Box>
            </Box>
          </Grid>

          {/* Reconocimientos */}
          <Grid size={{ xs: 12, md: 2 }}>
            <Typography variant="h6" sx={{ fontWeight: 'semibold', mb: 2 }}>
              Reconocimientos
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, alignItems: 'flex-start' }}>
              <Box component="img" src={MetaBusinessIcon} alt="Meta Business" sx={{ height: '5em', width: 'auto' }} />
            </Box>
          </Grid>
        </Grid>

        <Divider sx={{ borderColor: 'rgba(255, 255, 255, 0.2)' }} />

        {/* Footer Bottom */}
        <Box
          sx={{
            py: 3,
            display: 'flex',
            flexDirection: { xs: 'column', md: 'row' },
            justifyContent: 'space-between',
            alignItems: 'center',
            gap: 2,
          }}
        >
          <Typography variant="body2" sx={{ color: 'rgba(255, 255, 255, 0.7)', fontSize: '0.875rem' }}>
            © {currentYear} Glou SpA
          </Typography>
        </Box>
      </Container>
    </Box>
  );
};

export default Footer;
